import { getRelationshipDescription } from "../util/helpers";
import { ApiHandler as makeReq } from "./ApiHandler";

const API_BASE = "cdktalentacquisition/api";

export default {
  getPersonalDetails: candidateId => {
    return makeReq({
      url: `${API_BASE}/getuser`,
      method: "POST",
      data: {
        userId: candidateId
      }
    });
  },
  saveOnBoardingDetails: onBoardingDetails => {
    return makeReq({
      url: `${API_BASE}/updatecandidate`,
      method: "POST",
      data: onBoardingDetails
    });
  },
  getRelationshipList: loggedInUserId => {
    return makeReq({
      url: `${API_BASE}/getRelationShipList`,
      method: "GET",
      data: {
        loggedInUserId: loggedInUserId
      }
    });
  }
};
